export default __webpack_public_path__ + "static/media/logo-cure.63bf4d56.jpg";